import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';
import { get, update, remove } from '~/actions/bundles';
import Spinner from '~/components/Spinner';
import ArticlePicker from '~/components/ArticlePicker';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import MultiPickerCount from '~/components/MultiPickerCount';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const MultiArticlePicker = MultiPickerCount(ArticlePicker);
const MultiRawMaterialPicker = MultiPickerCount(RawMaterialPicker);

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bundle: null,
      changes: {},
    };
  }

  componentDidMount() {
    get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(r => this.setState({
        loading: false,
        bundle: r.data,
        changes: {}
      }))
      .catch(() => this.setState({ loading: false }));
  }

  submit() {
    return update(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id,
      this.state.changes
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  remove() {
    return remove(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  render() {
    if (this.state.loading) {
      return (
        <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            <Spinner />
          </div>
        </div>
      );
    }
    if (!this.state.loading && !this.state.bundle) {
      return (
        <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            Not found
          </div>
        </div>
      );
    }
    const articleIds = (this.state.changes.articleIds !== undefined
      ? this.state.changes.articleIds
      : this.state.bundle.articleIds
    );
    const rawMaterialIds = (this.state.changes.rawMaterialIds !== undefined
      ? this.state.changes.rawMaterialIds
      : this.state.bundle.rawMaterialIds
    );
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Input
                label="Name"
                required
                value={
                  this.state.changes.name !== undefined
                    ? this.state.changes.name
                    : this.state.bundle.name
                  }
                onChange={v =>
                  this.setState({ changes: { ...this.state.changes, name: v } })}
              />
              <Input
                label="UPC"
                required
                value={
                  this.state.changes.upc !== undefined
                    ? this.state.changes.upc
                    : this.state.bundle.upc
                  }
                onChange={v =>
                  this.setState({ changes: { ...this.state.changes, upc: v } })}
              />
              <div>Articles</div>
              <MultiArticlePicker
                value={articleIds}
                onChange={v =>
                  this.setState({ changes: { ...this.state.changes, articleIds: v } })}
              />
              <div>Raw materials</div>
              <MultiRawMaterialPicker
                value={rawMaterialIds}
                onChange={v =>
                  this.setState({ changes: { ...this.state.changes, rawMaterialIds: v } })}
              />
              <Button label="Save" icon="done" type="submit" primary raised />
              <Button
                className={styleLocal.buttonRemove}
                label="Delete"
                icon="clear"
                onClick={() => this.context.dialogPush('message', { content: 'Are you sure?', onConfirm: () => this.remove() })}
              />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/BundleEdit/index.js